/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/houseofq/"

const hoq: CommunityData = {
  code: "houseofq",
  inviteCode: "houseofq",
  name: "House of Q",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/hoq`,
  defaultCurrency: "SEK",
  socials: {},
  styles: {
    global: {
      counterColor: "#000000",
      logo: {
        src: `${S3_PREFIX}web-logo.jpg`,
        styles: "w-[128px] h-[130px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[128px] h-[130px] object-contain",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#ffffff",
      asideBg: "#ffffff",
      asideStyles: "border-r-[1px] border-black border-opacity-[15%]",
      contentBg: "",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.mp4?type=video`,
      bgMobile: `${S3_PREFIX}web-background-mobile.mp4?type=video`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.mp4?type=video`,
      mainFont: "font-['ABCDiatypeRegular']",
      primaryButton:
        "bg-[#000000] border-2 border-[#000000] rounded-[8px] px-[18px] py-[16px] text-[#ffffff] font-['KanitBold'] text-[16px] uppercase text-left leading-[110%]",
    },
    navigation: {
      iconsColor: "#000000",
      sideBarSeparator: "border-r-[1px] border-black border-opacity-[15%]",
      separator: "border-[#c0c0c0]",
      item: "font-['KanitBold'] text-[15px] text-[#000000] uppercase text-center leading-[110%] text-opacity-50 border-b border-[#c0c0c0] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#ffffff] rounded-[24px] !pb-8 overflow-hidden",
      titles: "text-[#000000] font-['KanitBold'] text-[24px] uppercase text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#757575] font-['ABCDiatypeRegular'] text-[15px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#c0c0c0]",
        sectionTitle:
          "text-[#000000] font-['KanitBold'] text-[24px] uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container: "w-[240px] sm:w-[256px] overflow-hidden bg-[#ffffff]",
          mediaContainer: "w-[240px] h-[240px] sm:w-[256px] sm:h-[256px] relative overflow-hidden",
          media: "w-[240px] h-[240px] sm:w-[256px] sm:h-[256px] object-cover",
          placeholderMedia: "w-[240px] h-[240px] sm:w-[256px] sm:h-[256px] bg-gray-400",
          content: "flex flex-col px-4 sm:px-0 py-4 bg-transparent",
          title: "text-[#000000] font-['KanitBold'] text-[20px] uppercase text-left leading-[110%]",
          subtitle:
            "text-[#757575] font-['ABCDiatypeRegular'] text-[15px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#c0c0c0]",
        sectionTitle:
          "text-[#000000] font-['KanitBold'] text-[24px] uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff]",
          mediaContainer:
            "w-full h-[200px] sm:!w-[228px] sm:!h-[128px] sm:flex-shrink-0 relative overflow-hidden",
          media: "w-full h-[200px] sm:!w-[228px] sm:!h-[128px] object-cover",
          placeholderMedia: "w-full h-[200px] sm:!w-[228px] sm:!h-[128px] bg-gray-400",
          content: "flex flex-col py-4 px-0 sm:py-0 sm:px-4 bg-transparent",
          title: "text-[#000000] font-['KanitBold'] text-[15px] uppercase text-left leading-[110%]",
          subtitle:
            "text-[#757575] font-['ABCDiatypeRegular'] text-[13px] text-left leading-[120%] mt-2",
          location:
            "text-[#757575] font-['ABCDiatypeRegular'] text-[13px] text-left leading-[120%] mt-1",
          date: "text-[#757575] font-['ABCDiatypeRegular'] text-[13px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#000000] font-['KanitBold'] text-[22px] uppercase text-left leading-[110%]",
        text: "text-[#000000] font-['ABCDiatypeRegular'] text-[17px] text-left leading-[120%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#000000] font-['KanitBold'] text-[24px] uppercase text-left leading-[110%] !mb-4 sm:mb-6",
      },
    },
    shopV2: {
      container: "mb-16 sm:p-8 p-4 sm:pb-8 !bg-[#ffffff] rounded-[24px]",
      header: "text-[#000000] font-['KanitBold'] text-[24px] uppercase text-left leading-[110%]",
      emptyState: "text-[#757575] font-['ABCDiatypeRegular'] text-[15px] text-left leading-[120%]",
      membershipSection: {
        container: "mb-8",
        header:
          "text-[#000000] font-['KanitBold'] text-[22px] uppercase text-left leading-[110%] mb-4",
        products: {
          container: "flex flex-col overflow-hidden",
          product: {
            container:
              "flex flex-row justify-between gap-4 leading-auto border-b border-[#c0c0c0] py-4 mb-4",
            media: "!hidden",
            mediaContainer: "",
            name: "text-[#000000] font-['KanitBold'] text-[15px] uppercase text-left leading-[110%]",
            description:
              "text-[#757575] font-['ABCDiatypeRegular'] text-[15px] text-left leading-[120%] !mt-1",
            price:
              "text-[#757575] font-['KanitBold'] text-[15px] uppercase text-left leading-[110%] !mt-1",
            quantity:
              "text-[#ffffff] font-['KanitBold'] text-[14px] uppercase text-left leading-[110%]",
            status:
              "text-[#757575] font-['KanitBold'] text-[15px] uppercase text-left leading-[110%]",
            counterContainer:
              "bg-[#000000] border-2 border-[#000000] rounded-[8px] px-[16px] py-[12px] gap-x-[16px] !w-fit !h-10",
            plusMinusColor: "#ffffff",
            button:
              "bg-[#000000] border-2 border-[#000000] rounded-[8px] px-[16px] py-[12px] text-[#ffffff] font-['KanitBold'] text-[14px] uppercase text-left leading-[110%] !w-fit",
            descriptionCutoff: 50,
          },
        },
      },
      eventSection: {
        container: "mb-8",
        header:
          "text-[#000000] font-['KanitBold'] text-[22px] uppercase text-left leading-[110%] mb-4",
        event: {
          container: "flex items-start gap-4 mb-4",
          dateBox:
            "bg-[#000000] p-2 w-[52px] h-[52px] flex flex-col items-center justify-center text-center rounded-[8px]",
          month: "text-[12px] font-['KanitBold'] uppercase leading-[16px] text-[#ffffff]",
          day: "text-[16px] font-['KanitBold'] uppercase leading-[16px] text-[#ffffff]",
          details: "flex-1",
          name: "text-[#000000] font-['KanitBold'] text-[16px] uppercase text-left leading-[110%]",
          date: "text-[#757575] font-['ABCDiatypeRegular'] text-[13px] text-left leading-[120%] mt-1",
          location:
            "text-[#757575] font-['ABCDiatypeRegular'] text-[13px] text-left leading-[120%] mt-1",
        },
        tickets: {
          container: "flex flex-col overflow-hidden",
          ticket: {
            container:
              "flex flex-row justify-between gap-4 leading-auto border-b border-[#c0c0c0] py-4 mb-4",
            media: "!hidden",
            mediaContainer: "",
            name: "text-[#000000] font-['KanitBold'] text-[15px] uppercase text-left leading-[110%]",
            description:
              "text-[#757575] font-['ABCDiatypeRegular'] text-[15px] text-left leading-[120%] !mt-1",
            price:
              "text-[#757575] font-['KanitBold'] text-[15px] uppercase text-left leading-[110%] !mt-1",
            quantity:
              "text-[#ffffff] font-['KanitBold'] text-[14px] uppercase text-left leading-[110%]",
            status:
              "text-[#757575] font-['KanitBold'] text-[15px] uppercase text-left leading-[110%]",
            counterContainer:
              "bg-[#000000] border-2 border-[#000000] rounded-[8px] px-[16px] py-[12px] gap-x-[16px] !w-fit !h-10",
            plusMinusColor: "#ffffff",
            button:
              "bg-[#000000] border-2 border-[#000000] rounded-[8px] px-[16px] py-[12px] text-[#ffffff] font-['KanitBold'] text-[14px] uppercase text-left leading-[110%] !w-fit",
            descriptionCutoff: 50,
          },
        },
      },
      merchSection: {
        container: "mb-8",
        header:
          "text-[#000000] font-['KanitBold'] text-[22px] uppercase text-left leading-[110%] mb-4",
        products: {
          container: "flex flex-col overflow-hidden",
          product: {
            container:
              "flex flex-row justify-between gap-4 leading-auto border-b border-[#c0c0c0] p-4 mb-4",
            media: "!hidden",
            mediaContainer: "",
            name: "text-[#000000] font-['KanitBold'] text-[15px] uppercase text-left leading-[110%]",
            description:
              "text-[#757575] font-['ABCDiatypeRegular'] text-[15px] text-left leading-[120%] !mt-1",
            price:
              "text-[#757575] font-['KanitBold'] text-[15px] uppercase text-left leading-[110%] !mt-1",
            quantity:
              "text-[#ffffff] font-['KanitBold'] text-[14px] uppercase text-left leading-[110%]",
            status:
              "text-[#757575] font-['KanitBold'] text-[15px] uppercase text-left leading-[110%]",
            counterContainer:
              "bg-[#000000] border-2 border-[#000000] rounded-[8px] px-[16px] py-[12px] gap-x-[16px] !w-fit !h-10",
            plusMinusColor: "#ffffff",
            button:
              "bg-[#000000] border-2 border-[#000000] rounded-[8px] px-[16px] py-[12px] text-[#ffffff] font-['KanitBold'] text-[14px] uppercase text-left leading-[110%] !w-fit",
            descriptionCutoff: 50,
          },
        },
      },
    },
    shopProductV2: {
      container: "flex flex-col sm:p-8 p-4 !bg-[#ffffff] border border-[#757575] rounded-[24px]",
      media: "w-full sm:!h-[486px] object-cover",
      title:
        "text-[#000000] font-['KanitBold'] text-[24px] uppercase text-left leading-[110%] mt-6",
      additionalDetails:
        "text-[#000000] font-['ABCDiatypeRegular'] text-[15px] text-left leading-[120%] mt-4",
      priceSection: "border-t border-[#c0c0c0] mt-6 pt-6",
      displayPrice:
        "text-[#000000] font-['KanitBold'] text-[22px] uppercase text-left leading-[110%]",
      shortTerms:
        "text-[#757575] font-['ABCDiatypeRegular'] text-[13px] text-left leading-[120%] mt-2",
      button:
        "bg-[#000000] border-2 border-[#000000] rounded-[8px] px-[18px] py-[16px] text-[#ffffff] font-['KanitBold'] text-[16px] uppercase text-left leading-[110%] !w-fit self-center",
    },
    eventV2: {
      container: "flex flex-col !bg-[#ffffff] rounded-[24px] !pb-8 overflow-hidden",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#c0c0c0]",
        media: "w-full h-[200px] sm:!w-[320px] sm:!h-[180px] object-cover sm:mb-4 !border-0",
        title: "text-[#000000] font-['KanitBold'] text-[24px] uppercase text-left leading-[110%]",
        subtitle:
          "text-[#757575] font-['ABCDiatypeRegular'] text-[15px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#000000] border-2 border-[#000000] rounded-[8px] px-[18px] py-[16px] gap-y-[6px] !w-fit mb-4 sm:mb-0 text-[#ffffff] font-['KanitBold'] !text-[16px] uppercase text-left leading-[110%]",
        questions: "text-[15px] text-left leading-[120%] text-[#000000]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#c0c0c0]",
        header: "text-[#000000] font-['KanitBold'] text-[22px] uppercase text-left leading-[110%]",
        text: "text-[#000000] font-['ABCDiatypeRegular'] text-[15px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#c0c0c0]",
        header: "text-[#000000] font-['KanitBold'] text-[22px] uppercase text-left leading-[110%]",
        text: "text-[#000000] font-['ABCDiatypeRegular'] text-[15px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px] border border-[#979797]",
        mapPinColor: "#000000",
        mapStrokeColor: "#00000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#000000] font-['KanitBold'] text-[22px] uppercase text-left leading-[110%]",
        text: "text-[#000000] font-['ABCDiatypeRegular'] text-[15px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#000000] font-['KanitBold'] text-[22px] uppercase text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#ffffff]  rounded-[24px] overflow-hidden",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#000000] border-2 border-[#000000] rounded-[8px] px-[16px] py-[12px] text-[#ffffff] font-['KanitBold'] text-[14px] uppercase text-left leading-[110%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#ffffff] border-b border-[#c0c0c0] py-4 mb-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#000000] font-['KanitBold'] text-[15px] uppercase text-left leading-[110%] mb-1",
          description:
            "text-[#757575] font-['ABCDiatypeRegular'] text-[15px] text-left leading-[120%] mb-1 flex flex-row",
          price: "text-[#757575] font-['KanitBold'] text-[15px] uppercase text-left leading-[110%]",
          quantity:
            "text-[#ffffff] font-['KanitBold'] text-[14px] uppercase text-left leading-[110%]",
          status:
            "text-[#757575] font-['KanitBold'] text-[15px] uppercase text-left leading-[110%]",
          counterContainer:
            "bg-[#000000] border-2 border-[#000000] rounded-[8px] px-[16px] py-[12px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#000000] border-2 border-[#000000] rounded-[8px] px-[16px] py-[12px] text-[#ffffff] font-['KanitBold'] text-[14px] uppercase text-left leading-[110%] !w-fit",
          plusMinusColor: "#ffffff",
        },
      },
    },
    linktree: {
      bgDesktop: `${S3_PREFIX}web-background-non-member.mp4?type=video`,
      bgMobile: `${S3_PREFIX}web-background-non-member.mp4?type=video`,
      bgColor: "#ffffff",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative px-4 py-12 sm:p-[64px] bg-[#ffffff]",
      communityInfo: {
        logo: "h-[128px] w-[128px] object-cover",
        name: "text-[#000000] font-['KanitBold'] text-[24px] uppercase text-center mt-4 mb-1",
        location: "text-[#000000] font-['KanitBold'] text-[16px] uppercase text-center mb-2",
        description:
          "text-[#000000] font-['ABCDiatypeRegular'] text-[17px] leading-[120%] text-center mb-4 max-w-[500px]",
        socialMediaIconColor: "#000000",
        button:
          "bg-[#000000] border-2 border-[#000000] rounded-[8px] px-[16px] py-[12px] text-[#ffffff] font-['KanitBold'] text-[14px] uppercase text-left leading-[110%] !w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ffffff] border border-[#757575] rounded-[8px] text-[#000000] font-['ABCDiatypeRegular'] text-[17px] leading-[120%] text-center",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] flex flex-col justify-center items-center p-[34px] mb-[32px] bg-[#ffffff] border border-[#757575] rounded-[8px]",
          title: "text-[#000000] font-['KanitBold'] text-[16px] uppercase text-center mb-1",
          text: "text-[#000000] font-['ABCDiatypeRegular'] text-[17px] leading-[120%] text-center",
          button:
            "bg-[#000000] border-2 border-[#000000] rounded-[8px] px-[16px] py-[12px] text-[#ffffff] font-['KanitBold'] text-[14px] uppercase text-left leading-[110%] !w-fit cursor-pointer mt-4",
        },
        header: "text-[#000000] font-['KanitBold'] text-[24px] uppercase text-center mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#ffffff] border border-[#757575] rounded-[8px]",
          duration:
            "text-[#757575] font-['ABCDiatypeRegular'] text-[13px] text-left leading-[120%]",
          name: "text-[#000000] font-['KanitBold'] text-[16px] uppercase text-left one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#000000",
          media: "overflow-hidden m-2",
        },
        event: {
          container:
            "overflow-hidden sm:w-[500px] w-[95vw] bg-[#ffffff] border border-[#757575] rounded-[8px]",
          name: "text-[#000000] font-['KanitBold'] text-[16px] uppercase text-left mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[64px] h-[64px] flex flex-col justify-center items-center gap-1 bg-[#000000] rounded-[6px] text-[#ffffff] font-['KanitBold'] text-[14px] uppercase text-center",
          duration:
            "text-[#757575] font-['ABCDiatypeRegular'] text-[13px] text-left leading-[120%]",
          location:
            "text-[#757575] font-['ABCDiatypeRegular'] text-[13px] text-left leading-[120%]",
          button:
            "bg-[#000000] border-2 border-[#000000] rounded-[8px] px-[16px] py-[12px] text-[#ffffff] font-['KanitBold'] text-[14px] uppercase text-left leading-[110%] !w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] px-4 py-3 flex justify-between gap-4 border-t border-[#757575]",
            name: "text-[#000000] font-['KanitBold'] text-[14px] uppercase text-left one-line-truncate sm:w-[390px] w-[65vw]",
            price: "text-[#000000] font-['KanitBold'] text-[14px] uppercase text-left",
            link: "text-[#757575] font-['ABCDiatypeRegular'] text-[13px] text-left leading-[120%]",
            status:
              "text-[#757575] font-['KanitBold'] text-[15px] uppercase text-left leading-[110%]",
            button:
              "bg-[#000000] border-2 border-[#000000] rounded-[8px] px-[16px] py-[12px] text-[#ffffff] font-['KanitBold'] text-[14px] uppercase text-left leading-[110%] !w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#000000] font-['ABCDiatypeRegular'] text-[17px] leading-[120%] text-center mt-4 cursor-pointer mb-[32px]",
      },
      news: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ffffff] border border-[#757575] rounded-[8px] text-[#000000] font-['ABCDiatypeRegular'] text-[17px] leading-[120%] text-center",
        header: "text-[#000000] font-['KanitBold'] text-[24px] uppercase text-center mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#ffffff] border border-[#757575] rounded-[8px]",
          name: "text-[#000000] font-['KanitBold'] text-[16px] uppercase text-left one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#000000",
          created: "text-[#757575] font-['ABCDiatypeRegular'] text-[13px] text-left leading-[120%]",
          media: "overflow-hidden m-2",
        },
        seeAllNews:
          "text-[#000000] font-['ABCDiatypeRegular'] text-[17px] leading-[120%] text-center mt-4 cursor-pointer mb-[32px]",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ffffff] border border-[#757575] rounded-[8px] text-[#000000] font-['ABCDiatypeRegular'] text-[17px] leading-[120%] text-center",
        header: "text-[#000000] font-['KanitBold'] text-[24px] uppercase text-center mb-[10px]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#ffffff] border border-[#757575] rounded-[8px]",
          coverUrl: "overflow-hidden m-2",
          duration:
            "text-[#757575] font-['ABCDiatypeRegular'] text-[13px] text-left leading-[120%]",
          liveType:
            "text-[#757575] font-['ABCDiatypeRegular'] text-[13px] text-left leading-[120%]",
          liveTypeCircle: "w-2 h-2 bg-[#000000] rounded-full",
          playIconColor: "#ffffff",
          playIconBackgroundColor: "#000000",
          playIconBorderColor: "#ffffff",
          start: "text-[#757575] font-['ABCDiatypeRegular'] text-[13px] text-left leading-[120%]",
          title:
            "text-[#000000] font-['KanitBold'] text-[16px] uppercase text-left one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#000000] font-['ABCDiatypeRegular'] text-[17px] leading-[120%] text-center mt-4 cursor-pointer mb-[32px]",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ffffff] border border-[#757575] rounded-[8px] text-[#000000] font-['ABCDiatypeRegular'] text-[17px] leading-[120%] text-center",
        header: "text-[#000000] font-['KanitBold'] text-[24px] uppercase text-center mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#ffffff] border border-[#757575] rounded-[8px]",
          name: "text-[#000000] font-['KanitBold'] text-[16px] uppercase text-left",
          triangleIconColor: "#000000",
          circleIcon: "ml-2 w-[24px] h-[24px] object-cover",
        },
      },
      footer: {
        WERZlogoColor: "#000000",
        text: "text-[#757575] font-['ABCDiatypeRegular'] text-[13px] text-left",
      },
    },
  },
}

export default hoq
